import React from "react";
import { Link } from "gatsby";

const AdvisoryFooter = () => (
  <footer className="ady-footer">
    <div className="container ady-footer__inner">
      <div><span className="ady-footer__brand">Ánh Dương<span> Advisory</span></span><p>Hệ điều hành quản trị EPC Solar toàn diện cho những nhà sáng lập kiến tạo di sản.</p></div>
      <div><span className="ady-footer__label">ĐIỀU HƯỚNG</span><Link to="/co-van-quan-tri-epc">Cố vấn quản trị EPC</Link><Link to="/hitech-talent">Ánh Dương Talent</Link><Link to="/cong-giao-dich/tham-dinh-doanh-nghiep">Phiên thẩm định</Link></div>
      <div><span className="ady-footer__label">KẾT NỐI</span><a href="mailto:hello@anhduong.advisory">hello@anhduong.advisory</a><p>Chỉ tiếp những Lãnh đạo sẵn sàng đối diện với sự thật.</p></div>
    </div>
    <div className="container ady-footer__bottom"><span>© 2026 Ánh Dương Advisory</span><span>TRẬT TỰ · DÒNG TIỀN · DI SẢN</span></div>
  </footer>
);

export default AdvisoryFooter;
